import { useRecoilValue } from "recoil";
import { toastsAtom } from "../../common/miscellaneous/toastsAtom";

export function useToastsValue() {
  return useRecoilValue(toastsAtom);
}
